/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as SingnowRouteImport } from './routes/singnow'
import { Route as JoinRouteImport } from './routes/join'
import { Route as HostRouteRouteImport } from './routes/host/route'
import { Route as IndexRouteImport } from './routes/index'
import { Route as TvIndexRouteImport } from './routes/tv/index'
import { Route as TvSidRouteImport } from './routes/tv/$sid'
import { Route as JCodeRouteImport } from './routes/j.$code'
import { Route as HostDashboardRouteImport } from './routes/host/dashboard'
import { Route as SSidRouteRouteImport } from './routes/s/$sid/route'
import { Route as SSidIndexRouteImport } from './routes/s/$sid/index'
import { Route as SSidAddRouteImport } from './routes/s/$sid/add'
import { Route as HostConsoleSidRouteImport } from './routes/host/console.$sid'

const SingnowRoute = SingnowRouteImport.update({
  id: '/singnow',
  path: '/singnow',
  getParentRoute: () => rootRouteImport,
} as any)
const JoinRoute = JoinRouteImport.update({
  id: '/join',
  path: '/join',
  getParentRoute: () => rootRouteImport,
} as any)
const HostRouteRoute = HostRouteRouteImport.update({
  id: '/host',
  path: '/host',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const TvIndexRoute = TvIndexRouteImport.update({
  id: '/tv/',
  path: '/tv/',
  getParentRoute: () => rootRouteImport,
} as any)
const TvSidRoute = TvSidRouteImport.update({
  id: '/tv/$sid',
  path: '/tv/$sid',
  getParentRoute: () => rootRouteImport,
} as any)
const JCodeRoute = JCodeRouteImport.update({
  id: '/j/$code',
  path: '/j/$code',
  getParentRoute: () => rootRouteImport,
} as any)
const HostDashboardRoute = HostDashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => HostRouteRoute,
} as any)
const SSidRouteRoute = SSidRouteRouteImport.update({
  id: '/s/$sid',
  path: '/s/$sid',
  getParentRoute: () => rootRouteImport,
} as any)
const SSidIndexRoute = SSidIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => SSidRouteRoute,
} as any)
const SSidAddRoute = SSidAddRouteImport.update({
  id: '/add',
  path: '/add',
  getParentRoute: () => SSidRouteRoute,
} as any)
const HostConsoleSidRoute = HostConsoleSidRouteImport.update({
  id: '/console/$sid',
  path: '/console/$sid',
  getParentRoute: () => HostRouteRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/host': typeof HostRouteRouteWithChildren
  '/join': typeof JoinRoute
  '/singnow': typeof SingnowRoute
  '/s/$sid': typeof SSidRouteRouteWithChildren
  '/host/dashboard': typeof HostDashboardRoute
  '/j/$code': typeof JCodeRoute
  '/tv/$sid': typeof TvSidRoute
  '/tv/': typeof TvIndexRoute
  '/host/console/$sid': typeof HostConsoleSidRoute
  '/s/$sid/add': typeof SSidAddRoute
  '/s/$sid/': typeof SSidIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/host': typeof HostRouteRouteWithChildren
  '/join': typeof JoinRoute
  '/singnow': typeof SingnowRoute
  '/host/dashboard': typeof HostDashboardRoute
  '/j/$code': typeof JCodeRoute
  '/tv/$sid': typeof TvSidRoute
  '/tv': typeof TvIndexRoute
  '/host/console/$sid': typeof HostConsoleSidRoute
  '/s/$sid/add': typeof SSidAddRoute
  '/s/$sid': typeof SSidIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/host': typeof HostRouteRouteWithChildren
  '/join': typeof JoinRoute
  '/singnow': typeof SingnowRoute
  '/s/$sid': typeof SSidRouteRouteWithChildren
  '/host/dashboard': typeof HostDashboardRoute
  '/j/$code': typeof JCodeRoute
  '/tv/$sid': typeof TvSidRoute
  '/tv/': typeof TvIndexRoute
  '/host/console/$sid': typeof HostConsoleSidRoute
  '/s/$sid/add': typeof SSidAddRoute
  '/s/$sid/': typeof SSidIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/host'
    | '/join'
    | '/singnow'
    | '/s/$sid'
    | '/host/dashboard'
    | '/j/$code'
    | '/tv/$sid'
    | '/tv/'
    | '/host/console/$sid'
    | '/s/$sid/add'
    | '/s/$sid/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/host'
    | '/join'
    | '/singnow'
    | '/host/dashboard'
    | '/j/$code'
    | '/tv/$sid'
    | '/tv'
    | '/host/console/$sid'
    | '/s/$sid/add'
    | '/s/$sid'
  id:
    | '__root__'
    | '/'
    | '/host'
    | '/join'
    | '/singnow'
    | '/s/$sid'
    | '/host/dashboard'
    | '/j/$code'
    | '/tv/$sid'
    | '/tv/'
    | '/host/console/$sid'
    | '/s/$sid/add'
    | '/s/$sid/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  HostRouteRoute: typeof HostRouteRouteWithChildren
  JoinRoute: typeof JoinRoute
  SingnowRoute: typeof SingnowRoute
  SSidRouteRoute: typeof SSidRouteRouteWithChildren
  JCodeRoute: typeof JCodeRoute
  TvSidRoute: typeof TvSidRoute
  TvIndexRoute: typeof TvIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/singnow': {
      id: '/singnow'
      path: '/singnow'
      fullPath: '/singnow'
      preLoaderRoute: typeof SingnowRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/join': {
      id: '/join'
      path: '/join'
      fullPath: '/join'
      preLoaderRoute: typeof JoinRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/host': {
      id: '/host'
      path: '/host'
      fullPath: '/host'
      preLoaderRoute: typeof HostRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/tv/': {
      id: '/tv/'
      path: '/tv'
      fullPath: '/tv/'
      preLoaderRoute: typeof TvIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/tv/$sid': {
      id: '/tv/$sid'
      path: '/tv/$sid'
      fullPath: '/tv/$sid'
      preLoaderRoute: typeof TvSidRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/j/$code': {
      id: '/j/$code'
      path: '/j/$code'
      fullPath: '/j/$code'
      preLoaderRoute: typeof JCodeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/host/dashboard': {
      id: '/host/dashboard'
      path: '/dashboard'
      fullPath: '/host/dashboard'
      preLoaderRoute: typeof HostDashboardRouteImport
      parentRoute: typeof HostRouteRoute
    }
    '/s/$sid': {
      id: '/s/$sid'
      path: '/s/$sid'
      fullPath: '/s/$sid'
      preLoaderRoute: typeof SSidRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/s/$sid/': {
      id: '/s/$sid/'
      path: '/'
      fullPath: '/s/$sid/'
      preLoaderRoute: typeof SSidIndexRouteImport
      parentRoute: typeof SSidRouteRoute
    }
    '/s/$sid/add': {
      id: '/s/$sid/add'
      path: '/add'
      fullPath: '/s/$sid/add'
      preLoaderRoute: typeof SSidAddRouteImport
      parentRoute: typeof SSidRouteRoute
    }
    '/host/console/$sid': {
      id: '/host/console/$sid'
      path: '/console/$sid'
      fullPath: '/host/console/$sid'
      preLoaderRoute: typeof HostConsoleSidRouteImport
      parentRoute: typeof HostRouteRoute
    }
  }
}

interface HostRouteRouteChildren {
  HostDashboardRoute: typeof HostDashboardRoute
  HostConsoleSidRoute: typeof HostConsoleSidRoute
}

const HostRouteRouteChildren: HostRouteRouteChildren = {
  HostDashboardRoute: HostDashboardRoute,
  HostConsoleSidRoute: HostConsoleSidRoute,
}

const HostRouteRouteWithChildren = HostRouteRoute._addFileChildren(
  HostRouteRouteChildren,
)

interface SSidRouteRouteChildren {
  SSidAddRoute: typeof SSidAddRoute
  SSidIndexRoute: typeof SSidIndexRoute
}

const SSidRouteRouteChildren: SSidRouteRouteChildren = {
  SSidAddRoute: SSidAddRoute,
  SSidIndexRoute: SSidIndexRoute,
}

const SSidRouteRouteWithChildren = SSidRouteRoute._addFileChildren(
  SSidRouteRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  HostRouteRoute: HostRouteRouteWithChildren,
  JoinRoute: JoinRoute,
  SingnowRoute: SingnowRoute,
  SSidRouteRoute: SSidRouteRouteWithChildren,
  JCodeRoute: JCodeRoute,
  TvSidRoute: TvSidRoute,
  TvIndexRoute: TvIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
